import i18next from 'i18next';
export default function getLocale() {
	//var lang = i18next.language;
	var lang = localStorage.getItem('i18nextLng');
	if (lang === 'es' || lang === 'es-US' || lang === 'undefined') {
		return 'es-MX';
	} else return 'en-US';
}
